import { Injectable, NgZone } from '@angular/core';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class AmbitService {

  public adminUser: any;
  public driverId: any;
  public passengerId: any;
  public tripId: any;
  public ticketId: any;
  public ticketDetails: any;
  public completedTrips: any;
  public totalEarnings: any;
  public adminsList: any = [];
  public driversList: any = [];
  public driverRequestsList: any = [];
  public passengersList: any = [];
  public allTransactionList: any = [];
  public filteredTransactionList: any = [];

  public completePayouts: any = [];
  public allWithdrawRequests: any = [];
  public filteredWithdrawRequests: any = [];
  public pendigPayoutsCount: number = 0;
  public pendigDriversCount: number = 0;
  public pendigCarsCount: number = 0;
  public pendigTicketsCount: number = 0;
  public allTicketsList: any = [];
  public allUsersList: any = [];
  public userAccountsList: any = [];
  public userDetails: any;
  public userAllBookings: any = [];
  public userTrips: any = [];
  public tripEarnings: any = [];
  public userCreditCards: any = [];
  public driverDetails: any;
  public tripDetails: any;
  public driverModel: any = {
    trips: [],
    vehicles: [],
    document: {},
    reviews: [],
  }
  public singleDriver: any = {
    trips: [],
    vehicles: [],
    documents: [],
    reviews: [],
  }
  public categoryList: any = [];
  public carList: any = [];

  public filteredTrips: any = [];
  public allTrips: any = [];

  public payoutDate: any;

  public searchedCity: any;

  constructor(public zone: NgZone) {
    this.fetchAmbitRecord();
  }

  fetchAmbitRecord() {

    if (this.adminUser || localStorage.getItem('AmbitUser')) {
      this.adminUser = JSON.parse(localStorage.getItem('AmbitUser'))
    } else {
      return;
    }
    if (!this.allTrips.length) {
      this.getAllTripsData();
    }
    if (!this.userCreditCards.length) {
      this.getUserCreditCards();
    }
    if (!this.userAllBookings.length) {
      this.getAllUserBookings();
    }
    if (!this.allWithdrawRequests.length) {
      this.getCompletedPayoutList();
    }
    if (!this.driversList.length) {
      this.getUsersData();
      this.getDirverDocReviewData()
    }
    if (!this.allTicketsList.length) {
      this.getTicketsData();
    } if (!this.carList.length) {
      this.getCarsData();
    } if (!this.userAccountsList.length) {
      this.getUserAccountDetails();
    } if (!this.allTransactionList.length) {
      this.getTransactionList();
    }
  }

  getAllTripsData() {
    var self = this;

    firebase.database().ref().child('Trips/')
      .on('value', function (snapshot) {
        self.allTrips = [];
        self.completedTrips = 0;
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].tripID = key;
            self.allTrips.push(data[key]);
            if (data[key].status && data[key].status == 'Completed') {
              self.completedTrips++;
            }
          }
          self.allTrips.reverse();
          self.filteredTrips = self.allTrips;
          if (self.tripId) {
            self.tripDetails = self.allTrips.find(ob => ob['tripID'] === self.tripId);
            //self.getTripDetailData(self.tripId);
          }
        }
      });

  }

  getAllUserBookings() {
    var self = this;

    firebase.database().ref().child('Bookings/')
      .on('value', function (snapshot) {
        self.userAllBookings = [];
        self.totalEarnings = 0;
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].tripID = key;
            self.userAllBookings.push(data[key]);

            var tripData = self.allTrips.find(ob => ob.tripID === key)
            if (tripData && tripData.status == 'Completed') {
              self.totalEarnings = self.totalEarnings + Number(data[key].total);
            }
          }

          if (self.tripId) {
            self.getTripEarnings();
          }
        }
      });


  }

  getUsersData() {
    var self = this;


    firebase.database().ref().child('Users')
      .on('value', function (snapshot) {
        self.allUsersList = [];
        self.driversList = [];
        self.driverRequestsList = [];
        self.passengersList = [];
        self.adminsList = [];

        var data = snapshot.val();
        if (data) {
          self.pendigDriversCount = 0;
          for (var key in data) {
            if (!data[key].userName) { data[key].userName = "" }
            data[key].userName = data[key].userName.toUpperCase();
            if (!data[key].phoneNumber) { data[key].phoneNumber = ""; }

            var card = self.userCreditCardsData(data[key].uid)
            if (card) {
              data[key].cards = card.paymentCards;
              data[key].creditCardCount = card.paymentCards.length;
            } else {
              data[key].cards = '';
              data[key].creditCardCount = 0;
            }

            self.allUsersList.push(data[key]);

            if (data[key].driver == true) {
              if (!data[key].totalEarnings) { data[key].totalEarnings = 0; }

              if (!data[key].status && data[key].status !== false) {
                data[key].status = 'Pending';
                self.pendigDriversCount++;
                self.driverRequestsList.push(data[key]);
              } else {
                if (data[key].status === false) {
                  data[key].status = 'Blocked';
                } else {
                  data[key].status = 'Active';
                }
                self.driversList.push(data[key]);
              }
              if (self.tripId && self.tripDetails.uid == data[key].uid) { self.tripDetails.driverInfo = data[key]; }
            } else if (!data[key].isAdmin) {
              if (!data[key].myCredits) {
                data[key].myCredits = 0;
              }
              if (!data[key].status && data[key].status !== false) {
                data[key].status = '';
              }
              self.passengersList.push(data[key]);
            } else {
              self.adminsList.push(data[key]);
            }
          }

          self.driversList.reverse();
          self.passengersList.reverse();
          self.updateTripDriverData();
          self.updatePassengerBookings();
          if (self.driverId) {
            self.getDriverDetailData(self.driverId);
          } if (self.passengerId) {
            self.getUserDetailData();
          }

          self.newUserAddedListner();

        }
      });

  }

  getTicketsData() {
    var self = this;

    firebase.database().ref().child('Quries/')
      .on('value', function (snapshot) {
        self.allTicketsList = [];
        self.pendigTicketsCount = 0;
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].ticketId = key;
            if (!data[key].status || data[key].status == 'Open') {
              data[key].status = 'Open';
              self.pendigTicketsCount++;
            }
            self.allTicketsList.push(data[key]);
          }
          if (self.ticketId) {
            self.getTicketDetails();
          }

        }
        self.newTicketListner();
      });

  }

  getCarsData() {
    var self = this;
    firebase.database().ref().child('VehicleCategory')
      .once('value', function (snapshot) {
        self.categoryList = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            self.categoryList.push(data[key]);
          }
        }
      });

    firebase.database().ref().child('Vehicles')
      .on('value', function (snapshot) {
        self.carList = [];
        var data = snapshot.val();
        if (data) {
          self.pendigCarsCount = 0;
          for (var key in data) {
            data[key].carId = key;

            if (!data[key].status || data[key].status == 'Pending') {
              self.pendigCarsCount++;
              data[key].status = 'Pending'
            }
            data[key].vehicleId = data[key].vehicleId.toUpperCase();
            data[key].vehicleModel = data[key].vehicleModel.toUpperCase();
            if (!data[key].vehicleMakes) {
              data[key].vehicleMakes = '';
            } else {
              data[key].vehicleMakes = data[key].vehicleMakes.toUpperCase();
            }
            self.carList.push(data[key]);
            if (self.tripId && self.tripDetails.vehicleId && self.tripDetails.vehicleId == key) {
              self.tripDetails.carInfo = data[key];
            }
            var index = self.driversList.findIndex(ob => ob['uid'] === data[key].uid);
            if (index >= 0) {

              if (!self.driversList[index].vehicles) {
                self.driversList[index].vehicles = [];
                self.driversList[index].vehicles.push(data[key]);
              } else {
                var carIndex = self.driversList[index].vehicles.findIndex(ob => ob['vehicleId'] === data[key].vehicleId);
                if (carIndex < 0) {
                  self.driversList[index].vehicles.push(data[key]);
                }
              }

              if (!self.driversList[index].vehicleCount) {
                self.driversList[index].vehicleCount = 1;
              } else {
                self.driversList[index].vehicleCount++;
              }
            }

          }

          self.carList.reverse();
        }

        self.newVehicleListner();
      });

  }

  getDirverDocReviewData() {
    var self = this;

    firebase.database().ref().child('DriverDocuments/')
      .on('value', function (snapshot,) {
        self.driverModel.documents = [];
        self.singleDriver.document = {};
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].docID = key;
            self.driverModel.documents.push(data[key]);

            if (self.driverId && self.driverId == data[key].uid) {
              self.singleDriver.document = data[key];
            }

          }
        }

        self.newDocumentListner();
      });

    firebase.database().ref().child('Reviews')
      .once('value', function (snapshot) {
        self.driverModel.reviews = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].reviewID = key;
            self.driverModel.reviews.push(data[key]);
          }
          self.getReviewUserName();
        }
        self.newReviewListner();
      }).catch((err) => {
        alert(err);
      });

  }

  getCompletedPayoutList() {
    var self = this;
    firebase.database().ref().child('Payouts/')
      .once('value', function (snapshot) {
        self.completePayouts = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].payOutID = key;
            self.completePayouts.push(data[key]);
          }
        }
      }).catch((err) => {
        console.log(err.message);
      });


    var currentDate = new Date();
    var cDay = currentDate.getDate();
    currentDate.setDate(15);
    if (cDay < 15) {
      var month = currentDate.getMonth();
      if (month - 1 >= 0) {
        currentDate.setMonth(month - 1);
      } else {
        currentDate.setMonth(11);
        currentDate.setFullYear(currentDate.getFullYear() - 1);
      }
    }
    var filterDate = Number(new Date(currentDate));

    firebase.database().ref().child('Earnings/')
      .once('value', function (snapshot) {

        self.allWithdrawRequests = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            if (data[key].timeStamp >= filterDate) {
              data[key].withdrawID = key;
              self.allWithdrawRequests.push(data[key]);
            }
          }

          // self.processWithdrawRequests(filterDate);
        }
      }).catch((err) => {
        alert(err);
      });

  }

  getUserAccountDetails() {
    var self = this;
    firebase.database().ref().child('BankDetails')
      .on('value', function (snapshot) {
        self.userAccountsList = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            self.userAccountsList.push(data[key]);
          }
        }
      });
  }

  getTransactionList() {
    var self = this;

    firebase.database().ref().child('Transactions/')
      .on('value', function (snapshot) {
        self.allTransactionList = [];
        self.filteredTransactionList = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].transactionID = key;
            data[key].timeStamp = new Date(data[key].timestamp).toISOString().split("T")[0];

            var passengerData = self.passengersList.find(ob => ob['uid'] === data[key].uid);
            if (passengerData) {
              data[key].name = passengerData.userName;
              data[key].email = passengerData.email;
              data[key].myCredits = passengerData.myCredits;
            } else {
              data[key].name = '';
              data[key].email = '';
              data[key].myCredits = 0;
            }

            self.allTransactionList.push(data[key]);
          }
          self.allTransactionList.reverse();
          self.checkTripStatus();
          self.filteredTransactionList = self.allTransactionList;

        }
      });

  }

  newUserAddedListner() {
    var self = this;
    var userListner = firebase.database().ref().child('Users');
    userListner.on("child_added", function (snapshot, previousChildKey) {
      self.zone.run(() => {

        var data = snapshot.val();
        if (self.allUsersList.findIndex(ob => ob['uid'] == data.uid) >= 0) {
          return;
        }
        var card = self.userCreditCardsData(data.uid)
        if (card) {
          data.cards = card.paymentCards;
          data.creditCardCount = card.paymentCards.length;
        } else {
          data.cards = '';
          data.creditCardCount = 0;
        }

        data.userName = data.userName.toUpperCase();
        if (!data.phoneNumber) {
          data.phoneNumber = "";
        }
        if (data.driver == true) {
          if (!data.status && data.status !== false) {
            data.status = 'Pending';
            self.pendigDriversCount++;
          } else if (data.status === false) {
            data.status = 'Blocked';
          } else {
            data.status = 'Active';
          }
          if (!data.totalEarnings) {
            data.totalEarnings = 0;
          }
          self.driversList.push(data);
          if (self.driverId) {
            self.getDriverDetailData(self.driverId);
          }
        } else if (!data.isAdmin) {
          if (!data.myCredits) {
            data.myCredits = 0;
          }
          if (!data.status && data.status !== false) {
            data.status = '';
          }
          self.passengersList.push(data);
          self.allUsersList.push(data);
        } else {
          self.adminsList.push(data);
        }

      });
    });
  }

  newTicketListner() {
    var self = this;

    var ticketListner = firebase.database().ref().child('Quries');
    ticketListner.on("child_added", function (snapshot, previousChildKey) {
      self.zone.run(() => {

        var data = snapshot.val();
        data.ticketId = snapshot.key;
        if (self.allTicketsList.findIndex(ob => ob['ticketId'] == data.ticketId) >= 0) {
          return;
        }
        if (!data.status || data.status == 'Open') {
          data.status = 'Open';
          self.pendigTicketsCount++;
        }
        self.allTicketsList.unshift(data);
        if (self.ticketId) {
          self.getTicketDetails();
        }

      });
    });
  }

  newVehicleListner() {
    var self = this;
    var carListner = firebase.database().ref().child('Vehicles');
    carListner.on("child_added", function (snapshot, previousChildKey) {
      self.zone.run(() => {

        var data = snapshot.val();
        data.carId = snapshot.key;
        if (self.carList.findIndex(ob => ob['carId'] == data.carId) >= 0) {
          return;
        }

        if (!data.status || data.status == 'Pending') {
          self.pendigCarsCount++;
          data.status = 'Pending'
        }
        data.vehicleId = data.vehicleId.toUpperCase();
        data.vehicleModel = data.vehicleModel.toUpperCase();
        if (!data.vehicleMakes) {
          data.vehicleMakes = '';
        } else {
          data.vehicleMakes = data.vehicleMakes.toUpperCase();
        }

        self.carList.unshift(data);

        if (self.tripId && self.tripDetails.vehicleId && self.tripDetails.vehicleId == data.carId) {
          self.tripDetails.carInfo = data;
        }
        var index = self.driversList.findIndex(ob => ob['uid'] === data.uid);
        if (index >= 0) {

          if (!self.driversList[index].vehicles) {
            self.driversList[index].vehicles = [];
            self.driversList[index].vehicles.push(data);
          } else {
            var carIndex = self.driversList[index].vehicles.findIndex(ob => ob['vehicleId'] === data.vehicleId);
            if (carIndex < 0) {
              self.driversList[index].vehicles.push(data);
            }
          }

          if (!self.driversList[index].vehicleCount) {
            self.driversList[index].vehicleCount = 1;
          } else {
            self.driversList[index].vehicleCount++;
          }
        }

        if (self.driverId && self.driverId == data.uid) {
          if (self.driverDetails.vehicles && self.driverDetails.vehicles.findIndex(ob => ob['uid'] === data.uid) >= 0) {
            return;
          } else {
            if (!self.driverDetails.vehicles || !self.driverDetails.vehicles.length) {
              self.driverDetails.vehicles = [];
            }
            self.driverDetails.vehicles.push(data);
          }

        }

      });
    });

  }

  newDocumentListner() {
    var self = this;
    var docListner = firebase.database().ref().child('DriverDocuments');
    docListner.on("child_added", function (snapshot, previousChildKey) {
      self.zone.run(() => {

        var data = snapshot.val();
        data.docID = snapshot.key;
        if (self.driverModel.documents.findIndex(ob => ob['docID'] == data.docID) >= 0) {
          return;
        }
        self.driverModel.documents.unshift(data);
        if (self.driverId && self.driverId == data.uid) {
          self.singleDriver.document = data;
        }

      });
    });
  }

  newReviewListner() {
    var self = this;
    var reviewListner = firebase.database().ref().child('Reviews');
    reviewListner.on("child_added", function (snapshot, previousChildKey) {
      self.zone.run(() => {
        var data = snapshot.val();
        data.reviewID = snapshot.key;
        if (self.driverModel.reviews.findIndex(ob => ob['reviewID'] == data.reviewID) >= 0) {
          return;
        }

        var userData = self.passengersList.find(ob => ob['uid'] === data.uid);
        if (userData) {
          data.riderName = userData.userName + ' , ' + userData.email;
        } else {
          data.riderName = '';
        }
        self.driverModel.reviews.unshift(data);
        if (self.driverId && self.driverId == data.driverId) {
          self.singleDriver.reviews.push(data);
        }

      });
    });
  }

  getUserCreditCards() {
    var self = this;
    firebase.database().ref().child('CreditCards')
      .once('value', function (snapshot) {
        self.userCreditCards = [];

        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            self.userCreditCards.push(data[key]);
          }
        }
      });
  }

  getUserDetailData() {
    var self = this;
    if (self.passengersList.length) {
      var passengerData = self.passengersList.find(ob => ob['uid'] === self.passengerId);
      if (passengerData) {
        self.userDetails = passengerData;
      }
    }
  }

  getDriverDetailData(uid) {
    var self = this;

    var driverData = self.driversList.find(ob => ob['uid'] === uid);
    if (!driverData) { driverData = self.driverRequestsList.find(ob => ob['uid'] === uid); }
    if (driverData) {
      self.driverDetails = driverData;
      self.getRiderName();
    }

    if (self.driverModel.reviews.length) {
      self.singleDriver.reviews = [];
      for (var i = 0; i < self.driverModel.reviews.length; i++) {
        if (uid == self.driverModel.reviews[i].driverId) {
          self.singleDriver.reviews.push(self.driverModel.reviews[i]);
        }
      }
    }

    if (self.driverModel.documents && self.driverModel.documents.length) {
      self.singleDriver.document = {};
      for (var i = 0; i < self.driverModel.documents.length; i++) {
        if (uid == self.driverModel.documents[i].uid) {
          self.singleDriver.document = self.driverModel.documents[i];
          break;
        }
      }

    }

  }

  updateTripDriverData() {
    var self = this;
    for (var i = 0; i < self.driversList.length; i++) {
      var tempDriver = Object.assign({}, self.driversList[i]);
      self.driversList[i]['trips'] = [];
      self.driversList[i]['tripCount'] = 0;

      for (var j = 0; j < self.allTrips.length; j++) {
        if (tempDriver.uid == self.allTrips[j].uid) {
          var tempTrip = Object.assign({}, self.allTrips[j])
          self.driversList[i].trips.push(tempTrip);
          self.driversList[i].tripCount++;
          if (!self.allTrips[j].driverName) {
            self.allTrips[j].driverName = tempDriver.userName;
            self.allTrips[j].driverEmail = tempDriver.email;
          }
        }
      }
      if (self.allWithdrawRequests.length) {
        self.processWithdrawRequests();
      }
    }
  }

  getDriverInfo(tripID) {
    var self = this;
    if (self.allTrips.length) {
      var tripData = self.allTrips.find(ob => ob['tripID'] === tripID)
      if (tripData) {
        return tripData.driverName + ' , ' + tripData.driverEmail
      }
    }
    return '';
  }

  updatePassengerBookings() {
    var self = this;
    for (var i = 0; i < self.passengersList.length; i++) {
      var tempPassenger = Object.assign({}, self.passengersList[i]);
      self.passengersList[i].trips = [];
      self.passengersList[i].tripCount = 0;
      for (var j = 0; j < self.userAllBookings.length; j++) {
        if (tempPassenger.uid == self.userAllBookings[j].userId) {
          var tempTrip = Object.assign({}, self.userAllBookings[j])
          self.passengersList[i].trips.push(tempTrip);
          self.passengersList[i].tripCount++;
          if (!self.userAllBookings[j].riderName) {
            self.userAllBookings[j].riderName = tempPassenger.userName;
            self.userAllBookings[j].riderEmail = tempPassenger.email;
          }
        }
      }

    }
  }

  getRiderName() {
    var self = this;

    if (self.driverDetails.trips && self.driverDetails.trips.length) {
      for (var i = 0; i < self.driverDetails.trips.length; i++) {
        var trip = self.userAllBookings.find(ob => ob['tripId'] === self.driverDetails.trips[i].tripID);
        if (trip) {
          self.driverDetails.trips[i].riderName = trip.riderName + ' , ' + trip.riderEmail;
        } else {
          self.driverDetails.trips[i].riderName = '';
        }
      }
    }
  }

  processWithdrawRequests() {
    var self = this;

    var currentDate = new Date();
    var cDay = currentDate.getDate();
    currentDate.setDate(15);
    if (cDay < 15) {
      var month = currentDate.getMonth();
      if (month - 1 >= 0) {
        currentDate.setMonth(month - 1);
      } else {
        currentDate.setMonth(11);
        currentDate.setFullYear(currentDate.getFullYear() - 1);
      }
    }
    var filterDate = Number(new Date(currentDate));

    var selectedPayouts = self.allWithdrawRequests.filter((user, index, self) =>
      index === self.findIndex((t) => (t.uid === user.uid)))
    var newList: any = [];
    for (var i = 0; i < selectedPayouts.length; i++) {
      var payoutData = self.completePayouts.find(ob => ob['uid'] === selectedPayouts[i].uid);
      if (!payoutData || payoutData.timeStamp < filterDate) {
        newList.push(Object.assign({}, selectedPayouts[i]));
      }
    }

    for (var i = 0; i < newList.length; i++) {
      newList[i].earnings = 0;
      var count = 0;
      for (var j = 0; j < self.allWithdrawRequests.length; j++) {
        if (self.allWithdrawRequests[j].uid == newList[i].uid) {
          count++;
          newList[i].earnings = newList[i].earnings + self.allWithdrawRequests[j].earnings
        }

      }
      newList[i].trips = count;
    }

    self.allWithdrawRequests = newList;
    for (var i = 0; i < self.completePayouts.length; i++) {
      self.allWithdrawRequests.push(Object.assign({}, self.completePayouts[i]));
    }
    self.pendigPayoutsCount = 0;
    for (var i = 0; i < self.allWithdrawRequests.length; i++) {

      if (!self.allWithdrawRequests[i].status || self.allWithdrawRequests[i].status == 'Pending') {
        self.pendigPayoutsCount++;
      }

      if (!self.allWithdrawRequests[i].name) {
        var driverData = self.driversList.find(ob => ob['uid'] === self.allWithdrawRequests[i].uid);
        if (driverData) {
          self.allWithdrawRequests[i].name = driverData.userName;
          self.allWithdrawRequests[i].email = driverData.email;
          self.allWithdrawRequests[i].myCredits = driverData.myCredits;
        } else {
          self.allWithdrawRequests[i].name = '';
          self.allWithdrawRequests[i].email = '';
          self.allWithdrawRequests[i].myCredits = 0;
        }
      }
    }
    self.filteredWithdrawRequests = self.allWithdrawRequests;
  }

  getReviewUserName() {
    var self = this;
    self.singleDriver.reviews = [];
    for (var i = 0; i < self.driverModel.reviews.length; i++) {
      var userData = self.passengersList.find(ob => ob['uid'] === self.driverModel.reviews[i].uid);
      if (userData) {
        self.driverModel.reviews[i].riderName = userData.userName + ' , ' + userData.email;
      } else {
        self.driverModel.reviews[i].riderName = '';
      }

      if (self.driverId && self.driverId == self.driverModel.reviews[i].driverId) {
        self.singleDriver.reviews.push(self.driverModel.reviews[i]);
      }
    }

  }

  userCreditCardsData(uid) {
    var self = this;
    var cardData = self.userCreditCards.find(ob => ob['uid'] === uid);
    if (cardData) {
      return cardData;
    }
    return '';
  }

  getTripEarnings() {
    var self = this;
    self.tripEarnings = [];
    for (var i = 0; i < self.userAllBookings.length; i++) {
      if (self.tripId == self.userAllBookings[i].tripId) {
        if (!self.tripEarnings.length) {
          self.tripEarnings.push(self.userAllBookings[i]);
        } else {
          var bookingData = self.tripEarnings.find(ob => ob.origin.cityID === self.userAllBookings[i].origin.cityID &&
            ob.destination.cityID === self.userAllBookings[i].destination.cityID);
          if (bookingData) {
            var index = self.tripEarnings.findIndex(x => x.userId === bookingData.userId);
            self.tripEarnings[index].seatsCount = self.tripEarnings[index].seatsCount + self.userAllBookings[i].seatsCount;
            self.tripEarnings[index].total = self.tripEarnings[index].total + self.userAllBookings[i].total;
          } else {
            self.tripEarnings.push(self.userAllBookings[i])
          }
        }
      }
    }
  }

  getTicketDetails() {
    var self = this;
    var ticketData: any = self.allTicketsList.find(ob => ob.ticketId === self.ticketId)
    this.ticketDetails = ticketData;
  }

  checkTripStatus() {
    var self = this;

    for (var i = 0; i < self.allTransactionList.length; i++) {
      var transactionData = self.allTransactionList[i];
      if (transactionData.status != 'Completed' && transactionData.status != 'Amount Reversed') {

        var index = self.allTrips.findIndex(x => x.tripID === transactionData.tripId);
        if (index >= 0 && self.allTrips[index].status == 'Cancelled') {
          self.reverseUserCredit(transactionData)
        } else if (index >= 0 && self.allTrips[index].status == 'Completed') {
          self.chnageTransactionStatus(transactionData, 'Completed')
        }
      }
    }
  }

  reverseUserCredit(transactionData) {
    var self = this;
    var updateData: any = {};

    updateData['Users/' + transactionData.uid + '/myCredits'] = transactionData.price + transactionData.myCredits;
    firebase.database().ref().update(updateData).then(() => {

      self.chnageTransactionStatus(transactionData, 'Amount Reversed')
    }).catch((error) => {
      console.log(error);
    });
  }

  chnageTransactionStatus(transactionData, value) {
    var self = this;
    var updateData: any = {};
    var index = self.allTransactionList.findIndex(x => x.transactionID === transactionData.transactionID);
    updateData['Transactions/' + transactionData.transactionID + '/status'] = value;
    firebase.database().ref().update(updateData).then(() => {
      self.allTransactionList[index].status = value;
      self.filteredTransactionList[index].status = value;
    }).catch((error) => {
      console.log(error);
    });
  }

  sendUserNotification(user, notificationData) {

    var self = this;
    if (!user.deviceToken) {
      var userData = self.allUsersList.find(ob => ob['uid'] === user.uid);
      if (!userData.deviceToken) {
        var result: any = {
          success: false,
          error: true,
        }
        return result;
      }
    }

    var addMessage = firebase.functions().httpsCallable('sendNotification');
    addMessage({
      title: notificationData.title,
      message: notificationData.message,
      deviceToken: user.deviceToken,
    }).then((result) => {
      return self.saveNotificationFirebase(notificationData, user.uid);
    }).catch((error) => {
      var result: any = {
        success: false,
        error: true,
      }
      console.log(error);
      return result;
    })

  }

  saveNotificationFirebase(notificationData, uid) {
    var self = this;
    var result: any = {
      success: false,
      error: false,
    }
    var updates = {};
    var newPostKey = firebase.database().ref().child('Notifications/').push().key;
    var postData = {
      title: notificationData.title,
      message: notificationData.message,
      uid: uid,
      timeStamp: Number(new Date()),
    };
    updates['/Notifications/' + "/" + newPostKey] = postData;
    firebase.database().ref().update(updates).then(() => {
      result.success = true;
      result.error = false;
      return result;
    }).catch((error) => {
      result.success = false;
      result.error = true;
      console.log(error);
      return result;

    });
  }

}